export enum IconCategoryId {
  GENERAL = 'GENERAL',
  ALERTS_AND_FEEDBACK = 'ALERTS_AND_FEEDBACK',
  ARROWS = 'ARROWS',
  CHARTS = 'CHARTS',
  COMMUNICATION = 'COMMUNICATION',
  DEVELOPMENT = 'DEVELOPMENT',
  EDUCATION = 'EDUCATION',
  EDITOR = 'EDITOR',
  FILES = 'FILES',
  FINANCE = 'FINANCE',
  IMAGES = 'IMAGES',
  LAYOUT = 'LAYOUT',
  MEDIA_AND_DEVICES = 'MEDIA_AND_DEVICES',
  SECURITY = 'SECURITY',
  TIME = 'TIME',
  TRAVEL = 'TRAVEL',
  USERS = 'USERS',
  COMPONENTS = 'COMPONENTS',
  LOGOS = 'LOGOS',
  AI = 'AI',
  CUSTOM = 'CUSTOM',
  UNCATEGORIZED = 'UNCATEGORIZED',
}
